import { ActionTypes } from '../constants';
import { selectOptions } from './options';
import { calcPrice } from './';
import { devLog } from '../functions';

export const postNumToPrintNum = () => (dispatch, getState) => {
  const state = getState();
  const postNum = state.areas.sumNum;
  const option = state.options.printNumType.find(
    (x, i, self) => postNum <= x.num || i === self.length - 1
  );

  if (state.options.rules.maxPostNum < state.areas.sumNum) {
    const error =
      '配布可能部数を超えています。大量部数のご注文は別途お問合せください。';
    devLog(error);
    dispatch({ type: ActionTypes.ERROR_AREAS, key: 'maxPostNum', msg: error });
  } else {
    dispatch({ type: ActionTypes.ERROR_AREAS, key: 'maxPostNum', msg: null });
  }
  if (option !== undefined && 'value' in option) {
    dispatch(selectOptions({ printNumTypeId: option.value }));
  } else {
    dispatch(calcPrice());
  }
};

export const addAreaToList = (list, areaIds) => (dispatch, getState) => {
  dispatch({
    type: ActionTypes.ADD_AREA_TO_LIST,
    list: list,
    areaIds: areaIds
  });
  // dispatch(calcPrice())
  dispatch(postNumToPrintNum());
  // dispatch( checkRules() );
};

export const removeAreaFromList = areaId => (dispatch, getState) => {
  dispatch({ type: ActionTypes.REMOVE_AREA_FROM_LIST, areaId: areaId });
  // dispatch(calcPrice())
  dispatch(postNumToPrintNum());
};

export const setRootAreaId = rootAreaId => {
  return { type: ActionTypes.SET_ROOT_AREA_ID, rootAreaId: rootAreaId };
};

export const checkAreaNum = (num, maxNum) => {
  let error;
  if (!isNaN(num) && (num + '').match(/^[0-9]*$/)) {
    if (num > maxNum) {
      error = '配布可能部数を超えています';
    }
  } else if (num === '') {
    num = 0;
    error = '';
  } else {
    num = 0;
    error = '選択部数の入力が不正です';
  }
  return { num, error };
};

export const changeAreaNum = (id, value, maxNum) => (dispatch, getState) => {
  const { num, error } = checkAreaNum(
    value * process.env.REACT_APP_POST_NUM_SHIFT,
    maxNum
  );
  dispatch({
    type: ActionTypes.CHANGE_AREA_NUM,
    areaId: id,
    num: num,
    error: error
  });
  // dispatch(calcPrice())
  dispatch(postNumToPrintNum());
};

export const resetAreasDialog = (open) => (dispatch, getState) => {
	dispatch({ type: ActionTypes.RESET_AREAS_DIALOG, open });
}



// WEBPACK FOOTER //
// ./src/actions/areas.js